import { colors } from '@checkatrade/web-ui/themes';

const SvgComponent = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    className={className}
  >
    <g clipPath="url(#a)">
      <path
        fill={colors.secondary[100]}
        d="m77.84 31.998 3.16-7 7-3.16c1.56-.72 1.56-2.92 0-3.64l-7-3.16-3.16-7.04c-.72-1.56-2.92-1.56-3.64 0l-3.16 7-7.04 3.16c-1.56.72-1.56 2.92 0 3.64l7 3.16 3.16 7.04c.72 1.56 2.96 1.56 3.68 0Zm-31.84 6-6.36-14c-1.4-3.12-5.88-3.12-7.28 0l-6.36 14-14 6.36c-3.12 1.44-3.12 5.88 0 7.28l14 6.36 6.36 14c1.44 3.12 5.88 3.12 7.28 0l6.36-14 14-6.36c3.12-1.44 3.12-5.88 0-7.28l-14-6.36Zm28.16 26-3.16 7-7 3.16c-1.56.72-1.56 2.92 0 3.64l7 3.16 3.16 7.04c.72 1.56 2.92 1.56 3.64 0l3.16-7 7.04-3.16c1.56-.72 1.56-2.92 0-3.64l-7-3.16-3.16-7.04c-.72-1.56-2.96-1.56-3.68 0Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h96v96H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
